import React from 'react'
import Layout from '../../layout'

function Groups() {
  return (
    <>
        <Layout props='groups'></Layout>
    </>
  )
}

export default Groups